const SET_HERO_BANNER = 'DASHBOARD/SET_HERO_BANNER'
const SET_HERO_BANNER_PROMOS_AND_EVENTS =
  'DASHBOARD/SET_HERO_BANNER_PROMOS_AND_EVENTS'
const SET_HERO_BANNERS = 'DASHBOARD/SET_HERO_BANNERS'
const SET_FEATURED = 'DASHBOARD/SET_FEATURED'
const SET_FEATURE_STATUS = 'DASHBOARD/SET_FEATURE_STATUS'
const SET_OFFERS = 'DASHBOARD/SET_OFFERS'
const SET_PROMOS = 'DASHBOARD/SET_PROMOS'
const SET_EVENTS = 'DASHBOARD/SET_EVENTS'
const SET_MOVIES = 'DASHBOARD/SET_MOVIES'
const SET_MALLS = 'DASHBOARD/SET_MALLS'
const SET_CMS_MALLS = 'DASHBOARD/SET_CMS_MALLS'
const SET_MERCHANTS = 'DASHBOARD/SET_MERCHANTS'
const SET_EVENT_MODAL_DATA = 'DASHBOARD/SET_EVENT_MODAL_DATA'
const SET_EVENT_MODAL_STATUS = 'DASHBOARD/SET_EVENT_MODAL_STATUS'
const SET_PROMO_MODAL_DATA = 'DASHBOARD/SET_PROMO_MODAL_DATA'
const SET_PROMO_MODAL_STATUS = 'DASHBOARD/SET_PROMO_MODAL_STATUS'
const SET_MARKETING_CONTENT_DATA = 'DASHBOARD/SET_MARKETING_CONTENT_DATA'
const SET_MARKETING_CONTENT_STATUS = 'DASHBOARD/SET_MARKETING_CONTENT_STATUS'
const SET_MERCHANTS_LIST_MODAL_DATA = 'DASHBOARD/SET_MERCHANTS_LIST_MODAL_DATA'
const SET_STORE_MODAL_DATA = 'DASHBOARD/SET_STORE_MODAL_DATA'
const SET_DEVICE_LOCATION = 'DASHBOARD/SET_DEVICE_LOCATION'
const SET_CURRENT_MALL_IN_MODAL = 'DASHBOARD/SET_CURRENT_MALL_IN_MODAL'
const SET_OUR_MALL_MODAL_STATUS = 'DASHBOARD/SET_OUR_MALL_MODAL_STATUS'
const SET_CARD_LIST_MODAL_DATA = 'DASHBOARD/SET_CARD_LIST_MODAL_DATA'
const SET_CARD_LIST_MODAL_STATUS = 'DASHBOARD/SET_CARD_LIST_MODAL_STATUS'
const SET_CINEMAS = 'DASHBOARD/SET_CINEMAS'
const SET_PASYAL_ARTICLES = 'DASHBOARD/SET_PASYAL_ARTICLES'
// TODO: add more action types if necessary

export {
  SET_HERO_BANNER,
  SET_HERO_BANNERS,
  SET_FEATURED,
  SET_FEATURE_STATUS,
  SET_OFFERS,
  SET_PROMOS,
  SET_EVENTS,
  SET_MOVIES,
  SET_MALLS,
  SET_CMS_MALLS,
  SET_MERCHANTS,
  SET_EVENT_MODAL_DATA,
  SET_EVENT_MODAL_STATUS,
  SET_PROMO_MODAL_DATA,
  SET_PROMO_MODAL_STATUS,
  SET_MARKETING_CONTENT_DATA,
  SET_MARKETING_CONTENT_STATUS,
  SET_MERCHANTS_LIST_MODAL_DATA,
  SET_STORE_MODAL_DATA,
  SET_DEVICE_LOCATION,
  SET_CURRENT_MALL_IN_MODAL,
  SET_OUR_MALL_MODAL_STATUS,
  SET_CARD_LIST_MODAL_DATA,
  SET_CARD_LIST_MODAL_STATUS,
  SET_CINEMAS,
  SET_PASYAL_ARTICLES,
  SET_HERO_BANNER_PROMOS_AND_EVENTS,
  // TODO: export action types added later
}
